/* src/app/components/navigation-menu/navigation-menu.component.scss */
.nav-menu {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 18px;
  gap: 4px;
}
.menu-item-group {
  width: 100%;
}
.menu-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 14px 16px;
  font-size: 14pt;
  font-family: "OpenSans-ExtraBold";
  text-decoration: none;
  color: #0e4c6b;
  border-radius: 8px;
  cursor: pointer;
}
.menu-item-expandable {
  gap: 0;
}
.menu-item:hover:not(.menu-item-active) {
  background-color: rgba(242, 242, 242, 0.5019607843);
}
.menu-item-active {
  background-color: #f2f2f2;
}
.menu-item-icon {
  margin-right: 16px;
}
.menu-item-text {
  flex: 1;
  font-size: 12pt;
  font-family: "OpenSans-ExtraBold";
  text-decoration: none;
  color: #0e4c6b;
}
.menu-item-expand-indicator {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.15s ease;
}
.menu-item-expandable:hover .menu-item-expand-indicator,
.menu-item-expanded .menu-item-expand-indicator {
  opacity: 1;
  transition: opacity 0.15s ease;
}
.menu-item-expand-chevron {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-right: 2px solid #0e4c6b;
  border-bottom: 2px solid #0e4c6b;
  transform: rotate(-45deg);
  transition: transform 0.15s ease;
}
.menu-item-expanded .menu-item-expand-chevron {
  transform: rotate(45deg);
}
.submenu {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 4px 0 10px 32px;
}
.submenu-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 12px 16px;
  font-size: 12pt;
  text-decoration: none;
  color: #0e4c6b;
  border-radius: 8px;
  cursor: pointer;
}
.submenu-item:hover:not(.submenu-item-active) {
  background-color: rgba(242, 242, 242, 0.5019607843);
}
.submenu-item-active {
  background-color: #f2f2f2;
}
.submenu-item-text {
  font-size: 11pt;
  font-family: "OpenSans-ExtraBold";
  text-decoration: none;
  color: #0e4c6b;
}
ion-menu-toggle {
  width: 100%;
}
ion-content {
  height: 100%;
}
body {
  background-color: #f2f2f2;
}
/*# sourceMappingURL=navigation-menu.component.css.map */
